/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Cancelar"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Haz obtenido una justificación del negocio para acceder a los datos del cliente"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Tu actividad de descarga se registrará y se realizará un seguimiento para fines de cumplimiento de normas de seguridad"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "¿Deseas continuar?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Al descargar, reconoces lo siguiente:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
